// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta)
      .forEach((id) => {
        const node = document.querySelector(`.${id}`);

        if (node) {
          node.innerHTML = meta[id];
        }
      });
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

const CNNPolitics = false;
const CNNBusiness = true;

stylePremium(CNNPolitics, CNNBusiness);

function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = isMobile ? 1 : (9 / 16);
  const initialHeight = heightMultiplier * safeWidth;

  const { calloutValue, calloutLabel, recessionEnd } = meta;

  const props = {
    initialWidth: safeWidth, initialHeight, isMobile, calloutValue, calloutLabel, recessionEnd,
  };

  const graphicConfig = config(props);
  graphic(graphicConfig, container, isMobile);
}
